import React from 'react';
import { Stack } from 'components/stack';
import { Typography } from '@mui/material';
import { NotebookPatientInfo } from '../notebook-patient-info';
import style from './index.module.scss';

interface Props {
  userPatientProfileID: string;
  mainTitle: string;
}
export const NotebookDialogTitle: React.FC<React.PropsWithChildren<Props>> = ({
  userPatientProfileID,
  mainTitle,
}) => {
  return (
    <Stack
      className={style.root}
      spacing={1}
      sx={{
        alignItems: 'center',
      }}
    >
      <Typography
        component={'h1'}
        variant={'h3'}
        color={'secondary'}
        style={{ flexGrow: 1, fontWeight: 'bold' }}
      >
        {mainTitle}
      </Typography>
      <div>
        <NotebookPatientInfo userPatientProfileID={userPatientProfileID} />
      </div>
    </Stack>
  );
};
